// Marshall Data Imports
import minorII from '../../../assets/marshall/headphones/h1.PNG';
import modeII from '../../../assets/marshall/headphones/h2.PNG';
import motifANC from '../../../assets/marshall/headphones/h3.PNG';
import midANC from '../../../assets/marshall/headphones/h4.PNG';
import midBT from '../../../assets/marshall/headphones/h5.PNG';
import monitorANC from '../../../assets/marshall/headphones/h6.PNG';
import majorIII from '../../../assets/marshall/headphones/h7.PNG';
import monitor from '../../../assets/marshall/headphones/h9.PNG';
import majorIIIvoice from '../../../assets/marshall/headphones/h10.PNG';

import willen from "../../../assets/marshall/ms1.png";
import embertonII from "../../../assets/marshall/ms2.png";
import emberton from "../../../assets/marshall/ms3.png";
import stockwellII from "../../../assets/marshall/ms4.png";
import kilburnII from "../../../assets/marshall/ms5.png";
import tufton from "../../../assets/marshall/ms6.png";

// Muvtech Data Imports
import troysnap from '../../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap.png';
import troysnap2 from '../../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap2.png';
import troysnap3 from '../../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap3.png';
import troysnap4 from '../../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap4.png';
import troysnap5 from '../../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap5.png';
import troysnap6 from '../../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap6.png';
import troysnap7 from '../../../assets/muvtech/Muvdata/iphonecases/troy-snap/troy-snap7.png';

import yorksnap from '../../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap.png';
import yorksnap2 from '../../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap2.png';
import yorksnap3 from '../../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap3.png';
import yorksnap4 from '../../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap4.png';
import yorksnap5 from '../../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap5.png';
import yorksnap6 from '../../../assets/muvtech/Muvdata/iphonecases/york-snap/york-snap6.png';

import riosnap from '../../../assets/muvtech/Muvdata/iphonecases/rio-snap/rio-snap.png';
import evosnap from '../../../assets/muvtech/Muvdata/iphonecases/evo-snap/evo-snap.png';

import juice from '../../../assets/muvtech/Muvdata/powerbank/juice.png';
import minlight from '../../../assets/muvtech/Muvdata/powerbank/minlight.png';
import pocket from '../../../assets/muvtech/Muvdata/powerbank/pocket.png';
import pocketpro from '../../../assets/muvtech/Muvdata/powerbank/pocketpro.png';
import slim from '../../../assets/muvtech/Muvdata/powerbank/slim.png';
import slimpro from '../../../assets/muvtech/Muvdata/powerbank/slimpro.png';
import tank from '../../../assets/muvtech/Muvdata/powerbank/Tank.png';
import ultraslim from '../../../assets/muvtech/Muvdata/powerbank/ultraslim.png';

// iPad Type Case Imports
import ipadCase1 from '../../../assets/accessories/iPadTypeCase/EdgeKeyboardCase1.png';
import ipadCase2 from '../../../assets/accessories/iPadTypeCase/EdgeKeyboardCase2.png';
import ipadCase3 from '../../../assets/accessories/iPadTypeCase/EdgeKeyboardCase3.png';
import ipadCase4 from '../../../assets/accessories/iPadTypeCase/EdgeKeyboardCase4.png';
import ipadCase5 from '../../../assets/accessories/iPadTypeCase/EdgeKeyboardCase5.png';

// Typecase Edge Magic Style Keyboard Imports
import typecaseEdge1 from '../../../assets/accessories/TypecaseEdgeMagicStyleKeyboard/TypecaseEdgeStyle1.png';
import typecaseEdge2 from '../../../assets/accessories/TypecaseEdgeMagicStyleKeyboard/TypecaseEdgeStyle2.png';
import typecaseEdge3 from '../../../assets/accessories/TypecaseEdgeMagicStyleKeyboard/TypecaseEdgeStyle3.png';
import typecaseEdge4 from '../../../assets/accessories/TypecaseEdgeMagicStyleKeyboard/TypecaseEdgeStyle4.png';
import typecaseEdge5 from '../../../assets/accessories/TypecaseEdgeMagicStyleKeyboard/TypecaseEdgeStyle5.png';

// Typecase Flexbook Touch Keyboard Imports
import flexbookTouch1 from '../../../assets/accessories/TypecaseFlexbookTouch/FlexbookTouch1.png';
import flexbookTouch2 from '../../../assets/accessories/TypecaseFlexbookTouch/FlexbookTouch2.png';
import flexbookTouch3 from '../../../assets/accessories/TypecaseFlexbookTouch/FlexbookTouch3.png';
import flexbookTouch4 from '../../../assets/accessories/TypecaseFlexbookTouch/FlexbookTouch4.png';
import flexbookTouch5 from '../../../assets/accessories/TypecaseFlexbookTouch/FlexbookTouch5.png';
import flexbookTouch6 from '../../../assets/accessories/TypecaseFlexbookTouch/FlexbookTouch6.png';

// Detachable Keyboard Case Imports
import detachableCase1 from '../../../assets/accessories/DetachableKeyboardCase/DetachableKeyboardCase1.png';
import detachableCase2 from '../../../assets/accessories/DetachableKeyboardCase/DetachableKeyboardCase2.png';
import detachableCase3 from '../../../assets/accessories/DetachableKeyboardCase/DetachableKeyboardCase3.png';
import detachableCase4 from '../../../assets/accessories/DetachableKeyboardCase/DetachableKeyboardCase4.png';
import detachableCase5 from '../../../assets/accessories/DetachableKeyboardCase/DetachableKeyboardCase5.png';

// Detachable Keyboard Case 2 Imports
import detachableCase21 from '../../../assets/accessories/DetachableKeyboardCase2/DetachableKeyboardCase21.png';
import detachableCase22 from '../../../assets/accessories/DetachableKeyboardCase2/DetachableKeyboardCase22.png';
import detachableCase23 from '../../../assets/accessories/DetachableKeyboardCase2/DetachableKeyboardCase23.png';
import detachableCase24 from '../../../assets/accessories/DetachableKeyboardCase2/DetachableKeyboardCase24.png';
import detachableCase25 from '../../../assets/accessories/DetachableKeyboardCase2/DetachableKeyboardCase25.png';

// Marshall Products
const marshallProducts = [
  {
    id: 'marshall-1',
    name: 'MID A.N.C.',
    brand: 'Marshall',
    category: 'Audio',
    price: 14999,
    image: midANC,
    inStock: true,
    stockCount: 15,
    description: 'AN ICON REBORN - Meet Major IV, the iconic headphones from Marshall with 80+ solid hours of wireless playtime, wireless charging, and a new ergonomic design.',
    features: ['80+ hours playtime', 'Wireless charging', 'Iconic sound', 'Foldable design', 'Multi-directional control knob']
  },
  {
    id: 'marshall-2',
    name: 'MID BLUETOOTH',
    brand: 'Marshall',
    category: 'Audio',
    price: 14499,
    image: midBT,
    inStock: true,
    stockCount: 12,
    description: 'SUPERIOR SOUND - Mid Bluetooth is a premium wireless headphone that delivers superior audio with 30+ hour battery life.',
    features: ['Bluetooth aptX', '30+ hours playtime', 'Superior sound', 'Comfortable fit']
  },
  {
    id: 'marshall-3',
    name: 'MONITOR II A.N.C.',
    brand: 'Marshall',
    category: 'Audio',
    price: 29999,
    image: monitorANC,
    inStock: true,
    stockCount: 8,
    description: 'SUPERIOR SIGNATURE SOUND - Monitor II A.N.C. headphones deliver high-performance sound with advanced active noise cancelling technology.',
    features: ['Active noise cancelling', '30+ hours playtime with ANC', 'Customizable EQ', 'Comfortable ergonomic design']
  },
  {
    id: 'marshall-4',
    name: 'MAJOR III',
    brand: 'Marshall',
    category: 'Audio',
    price: 12999,
    image: majorIII,
    inStock: true,
    stockCount: 20,
    description: 'REDEFINING A CLASSIC - Major III Bluetooth is the next chapter in the revolutionary history of Marshall.',
    features: ['Bluetooth aptX', '30+ hours playtime', 'Iconic sound', 'Custom 40mm dynamic drivers']
  },
  {
    id: 'marshall-5',
    name: 'MINOR III',
    brand: 'Marshall',
    category: 'Audio',
    price: 19999,
    image: minorII,
    inStock: true,
    stockCount: 18,
    description: 'FRONT ROW SOUND WITH ACTIVE NOISE CANCELLATION - These true wireless headphones come with Active Noise Cancellation.',
    features: ['Active Noise Cancellation', 'Bluetooth 5.2', 'Wireless Charging', 'IPX5 Water Resistant', '20+ hours of total playtime with ANC']
  },
  {
    id: 'marshall-6',
    name: 'MODE II',
    brand: 'Marshall',
    category: 'Audio',
    price: 11999,
    image: modeII,
    inStock: true,
    stockCount: 25,
    description: 'ALL SOUND, NO FUSS - Minor III brings you Marshall\'s signature sound without the fuss.',
    features: ['Bluetooth 5.2', 'Touch Response', '25 hours of wireless playtime', 'Wireless Charging', 'IPX4 Water Resistant']
  },
  {
    id: 'marshall-7',
    name: 'MOTIF A.N.C.',
    brand: 'Marshall',
    category: 'Audio',
    price: 19999,
    image: motifANC,
    inStock: true,
    stockCount: 14,
    description: 'FRONT ROW SOUND WITH ACTIVE NOISE CANCELLATION - Getting the right sound means having control.',
    features: ['Active Noise Cancellation', 'Bluetooth 5.2', 'Wireless Charging', 'IPX5 Water Resistant', 'Customizable Touch Controls']
  },
  {
    id: 'marshall-8',
    name: 'MONITOR',
    brand: 'Marshall',
    category: 'Audio',
    price: 10999,
    image: monitor,
    inStock: true,
    stockCount: 22,
    description: 'LIGHT ON YOUR EARS, HEAVY ON SOUND - Minor II Bluetooth is an in-ear Bluetooth headphone engineered to stay in place.',
    features: ['Bluetooth aptX', '12 hours of wireless playtime', 'Magnetic pause function', 'Flexible ear-fit system']
  },
  {
    id: 'marshall-9',
    name: 'MAJOR III VOICE',
    brand: 'Marshall',
    category: 'Audio',
    price: 4499,
    image: majorIIIvoice,
    inStock: true,
    stockCount: 30,
    description: 'COMPACT SIGNATURE SOUND - Mode headphones deliver huge sound in a small package.',
    features: ['Custom tuned drivers', 'In-ear secure fit', 'Microphone and remote', 'L-shape plug for durability']
  },
  {
    id: 'marshall-10',
    name: 'WILLEN',
    brand: 'Marshall',
    category: 'Audio',
    price: 14999,
    image: willen,
    inStock: true,
    stockCount: 16,
    description: 'MIGHTY SOUND, EVERYWHERE - Willen is the mighty portable speaker that is made to go everywhere with you.',
    features: ['15+ hours of playtime', 'Bluetooth 5.1', 'IP67 waterproof and dustproof', 'Compact and rugged design', 'Stack Mode for multi-speaker pairing']
  },
  {
    id: 'marshall-11',
    name: 'EMBERTON II',
    brand: 'Marshall',
    category: 'Audio',
    price: 19999,
    image: embertonII,
    inStock: true,
    stockCount: 12,
    description: 'LOUDER, STRONGER, LONGER - Emberton II delivers sound that is rich, clear and loud, like the artist intended.',
    features: ['30+ hours of playtime', 'Bluetooth 5.1', 'True Stereophonic 360° sound', 'IP67 waterproof and dustproof', 'Stack Mode']
  },
  {
    id: 'marshall-12',
    name: 'TUFTON',
    brand: 'Marshall',
    category: 'Audio',
    price: 39999,
    image: tufton,
    inStock: true,
    stockCount: 6,
    description: 'KING OF THE ROAD - Bring the show on the road with Tufton, the mightiest portable speaker from Marshall.',
    features: ['20+ hours of playtime', 'Bluetooth 5.0', '3-way sound system', '360° Blumlein stereo sound', 'IPX2 water-resistant']
  },
  {
    id: 'marshall-13',
    name: 'EMBERTON',
    brand: 'Marshall',
    category: 'Audio',
    price: 17999,
    image: emberton,
    inStock: true,
    stockCount: 18,
    description: 'PACKS A PUNCH - Emberton is a compact portable speaker with the loud and vibrant sound only Marshall can deliver.',
    features: ['20+ hours of playtime', 'True Stereophonic (360° sound)', 'Compact and lightweight (0.7 kg)', 'IPX7 waterproof']
  },
  {
    id: 'marshall-14',
    name: 'STOCKWELL II',
    brand: 'Marshall',
    category: 'Audio',
    price: 22999,
    image: stockwellII,
    inStock: true,
    stockCount: 10,
    description: 'TRAVELS LIGHT, SOUNDS HEAVY - Built for life on the road, this compact portable speaker offers 20+ hours of playtime.',
    features: ['20+ hours of playtime', 'Bluetooth 5.0', 'Blumlein stereo sound', 'Multi-directional audio', 'IPX4 water-resistant']
  },
  {
    id: 'marshall-15',
    name: 'KILBURN II',
    brand: 'Marshall',
    category: 'Audio',
    price: 27999,
    image: kilburnII,
    inStock: true,
    stockCount: 8,
    description: 'A STOUT-HEARTED HERO - Free from the confines of wires and cords, this Bluetooth speaker offers 20+ hours of portable playtime.',
    features: ['20+ hours of playtime', 'Bluetooth 5.0', 'Multi-directional sound', 'Flush mounted corner caps', 'Water-resistant design']
  }
];

// Muvtech Products
const muvtechProducts = [
  {    id: 'muvtech-1',
    name: 'TROY SNAP iPhone Case',
    brand: 'Muvtech',
    category: 'Protection',
    price: 1999,
    image: troysnap,
    images: [troysnap, troysnap2, troysnap3, troysnap4, troysnap5, troysnap6, troysnap7],
    inStock: true,
    stockCount: 45,
    description: 'iPhone 16 Series compatible case with TPE material for drop and impact resistance.',
    features: ['Material: TPE', 'Drop & Impact resistant', 'Flexible yet rugged', 'iPhone 16 Series compatible']
  },
  {
    id: 'muvtech-2',
    name: 'YORK SNAP iPhone Case',
    brand: 'Muvtech',
    category: 'Protection',
    price: 1999,
    image: yorksnap,
    images: [yorksnap, yorksnap2, yorksnap3, yorksnap4, yorksnap5, yorksnap6],
    inStock: true,
    stockCount: 38,
    description: 'iPhone 16 Series case with 10ft drop test certification and air cushioning technology.',
    features: ['10ft Drop Tested', 'TPU structure with air cushioning', 'Absorbs 98% shock', 'Rounded air bumpers']
  },
  {
    id: 'muvtech-3',
    name: 'RIO SNAP iPhone Case',
    brand: 'Muvtech',
    category: 'Protection',
    price: 1799,
    image: riosnap,
    inStock: true,
    stockCount: 42,
    description: 'iPhone 16 Series case with foldable kickstand and MagSafe compatibility.',
    features: ['Foldable kickstand', 'Dual-layer TPU + PC', 'MagSafe compatible', 'Wireless charging (up to 20W)']
  },
  {
    id: 'muvtech-4',
    name: 'EVO SNAP iPhone Case',
    brand: 'Muvtech',
    category: 'Protection',
    price: 1999,
    image: evosnap,
    inStock: true,
    stockCount: 35,
    description: 'iPhone 16 Series case with foldable stand and MagSafe support.',
    features: ['Foldable stand + MagSafe', 'TPU + PC construction', 'Wireless charging (up to 20W)', 'iPhone 16 Series compatible']
  },
  {
    id: 'muvtech-5',
    name: 'Slim Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 4999,
    image: slim,
    inStock: true,
    stockCount: 28,
    description: '10000mAh power bank with MagSafe compatibility and PD 20W fast charging.',
    features: ['10000mAh capacity', 'MagSafe compatible', 'PD 20W fast charging', 'Metal + Silicone construction']
  },
  {
    id: 'muvtech-6',
    name: 'SlimPro Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 5999,
    image: slimpro,
    inStock: true,
    stockCount: 22,
    description: '10000mAh power bank with MagSafe and Apple Watch charging capabilities.',
    features: ['10000mAh capacity', 'MagSafe + Watch Charging', 'PD 20W fast charging', 'All smartphones compatible']
  },
  {
    id: 'muvtech-7',
    name: 'Minlite Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 3999,
    image: minlight,
    inStock: true,
    stockCount: 35,
    description: 'Compact 5000mAh power bank with PD 20W fast charging capability.',
    features: ['5000mAh capacity', 'PD 20W fast charging', 'Compact design', 'All smartphones compatible']
  },
  {
    id: 'muvtech-8',
    name: 'Ultraslim Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 3999,
    image: ultraslim,
    inStock: true,
    stockCount: 40,
    description: 'Ultra-thin 5000mAh power bank with only 10.5mm thickness.',
    features: ['5000mAh capacity', 'Slim body design', '10.5mm thin profile', 'All smartphones compatible']
  },
  {
    id: 'muvtech-9',
    name: 'Tank Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 6999,
    image: tank,
    inStock: true,
    stockCount: 18,
    description: 'High-capacity 20000mAh power bank with rugged design and PD 20W charging.',
    features: ['20000mAh capacity', 'PD 20W fast charging', 'Rugged design', 'All smartphones compatible']
  },
  {
    id: 'muvtech-10',
    name: 'Pocket Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 2999,
    image: pocket,
    inStock: true,
    stockCount: 50,
    description: 'Lightweight 5000mAh power bank with ABS construction.',
    features: ['5000mAh capacity', 'ABS construction', 'Lightweight design', 'All smartphones compatible']
  },
  {
    id: 'muvtech-11',
    name: 'PocketPro Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 3999,
    image: pocketpro,
    inStock: true,
    stockCount: 32,
    description: 'Slim 10000mAh power bank with ABS construction for durability.',
    features: ['10000mAh capacity', 'ABS construction', 'Slim profile', 'All smartphones compatible']
  },
  {
    id: 'muvtech-12',
    name: 'Juice Power Bank',
    brand: 'Muvtech',
    category: 'Power',
    price: 2999,
    image: juice,
    inStock: true,
    stockCount: 25,
    description: 'Compact 1200mAh magnetic wireless power bank with 2.5W charging.',
    features: ['1200mAh capacity', '2.5W Mag Wireless charging', 'Compact design', 'All smartphones compatible']
  }
];

// iPad Type Case Products
const ipadTypeCaseProducts = [
  {
    id: 'ipad-case-1',
    name: 'iPad Edge Keyboard Case',
    brand: 'Apple',
    category: 'Protection',
    price: 14999,
    originalPrice: 19999,
    image: ipadCase1,
    images: [ipadCase1, ipadCase2, ipadCase3, ipadCase4, ipadCase5],
    inStock: true,
    stockCount: 25,
    description: 'Multi-mode iPad keyboard case with 11-color backlit keys, precision touchpad, and adjustable stand. Features snap-on magnetic design for easy portability.',
    features: [
      'Multi-Mode Design: Typing, reading, sketching, and tablet modes',
      '11-Color Backlit Keys: 3 brightness levels for day or night',
      'Snap-On Magnetic Design: Attaches in seconds',
      'Comfortable Typing: Responsive, ergonomic keys',
      'Precision Touchpad: Full iPadOS gesture support',
      'Adjustable Stand: Up to 130° viewing angle',
      'Slim Detachable Case: 1.4mm thin, 130g lightweight with N54H magnets'
    ],
    compatibleModels: [
      'iPad 11th Gen (A16, 2025) & iPad 10th Generation (A2696, A2757, A2777)',
      'iPad Air 11-inch - M3 2025 / M2 2024 (A2902, A2903, A2904)',
      'iPad Air 10.9inch - 5th/4th Gen (A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Air 13 inch - M3 2025 / M2 2024 (A2898, A2899, A2900)',
      'iPad Pro 11-inch 4th/3rd/2nd/1st gen - 2018-2022 (A2759, A2435, A2761, A2762, A2377, A2301, A2459, A2460, A2228, A2068, A2230, A2231, A1980, A2013, A1934, A1979, A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Pro 12.9 - 6th/5th/4th/3rd Gen (A2436, A2437, A2764, A2766, A2378, A2379, A2461, A2462, A2229, A2069, A2232, A2233, A1876, A2014, A1895, A1983)',
      'iPad Pro 11-inch (M5/M4) 2025/2024 (A2836, A2837, A3006)',
      'iPad Pro 13-inch (M5 2025 / M4 2024) (A2925, A2926, A3007)'
    ]
  },
  {
    id: 'ipad-case-2',
    name: 'Typecase Edge Magic Style Keyboard',
    brand: 'Apple',
    category: 'Protection',
    price: 14999,
    originalPrice: 19999,
    image: typecaseEdge1,
    images: [typecaseEdge1, typecaseEdge2, typecaseEdge3, typecaseEdge4, typecaseEdge5],
    inStock: true,
    stockCount: 20,
    description: 'Transform your iPad into a laptop-style setup with 11-color backlit keys, precision touchpad, and floating cantilever design. Lightweight and portable for productivity on the go.',
    features: [
      '11-Color Backlit Keys: 3 brightness levels for any lighting condition',
      'Precision Touchpad: Full-area trackpad for smooth navigation',
      'Sturdy Magnetic Clasp: Secure closure with Pencil holder',
      'Laptop-Style Transformation: Sleek setup ideal for productivity',
      'Lightweight & Portable: Slim, travel-friendly design',
      'Floating Cantilever Design: Adjustable viewing angle'
    ],
    compatibleModels: [
      'iPad 11th Gen (A16, 2025) & iPad 10th Generation (A2696, A2757, A2777)',
      'iPad Air 11-inch - M3 2025 / M2 2024 (A2902, A2903, A2904)',
      'iPad Air 10.9inch - 5th/4th Gen (A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Air 13 inch - M3 2025 / M2 2024 (A2898, A2899, A2900)',
      'iPad Pro 11-inch 4th/3rd/2nd/1st gen - 2018-2022 (A2759, A2435, A2761, A2762, A2377, A2301, A2459, A2460, A2228, A2068, A2230, A2231, A1980, A2013, A1934, A1979, A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Pro 12.9 - 6th/5th/4th/3rd Gen (A2436, A2437, A2764, A2766, A2378, A2379, A2461, A2462, A2229, A2069, A2232, A2233, A1876, A2014, A1895, A1983)',
      'iPad Pro 11-inch (M5/M4) 2025/2024 (A2836, A2837, A3006)',
      'iPad Pro 13-inch (M5 2025 / M4 2024) (A2925, A2926, A3007)'
    ]
  },
  {
    id: 'ipad-case-3',
    name: 'Typecase Flexbook Touch Keyboard',
    brand: 'Apple',
    category: 'Protection',
    price: 9999,
    originalPrice: 11999,
    image: flexbookTouch1,
    images: [flexbookTouch1, flexbookTouch2, flexbookTouch3, flexbookTouch4, flexbookTouch5, flexbookTouch6],
    inStock: true,
    stockCount: 30,
    description: 'Versatile iPad keyboard case with precision trackpad, 11-color backlit keyboard, and 360° hinge for 7 use modes. Features smart protection with auto sleep/wake and Apple Pencil holder.',
    features: [
      'Precision Trackpad: Multi-gesture control for smooth navigation',
      '11-Color Backlit Keyboard: iPadOS shortcuts with adjustable RGB backlight',
      '7 Use Modes: 360° hinge (20,000-cycle tested) for flexible viewing',
      'Smart Protection: Auto sleep/wake with Apple Pencil holder',
      'Sturdy Design: Secure magnetic attachment for stability'
    ],
    compatibleModels: [
      'iPad 11th Gen (A16, 2025) & iPad 10th Generation (A2696, A2757, A2777)',
      'iPad Air 11-inch - M3 2025 / M2 2024 (A2902, A2903, A2904)',
      'iPad Air 10.9inch - 5th/4th Gen (A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Air 13 inch - M3 2025 / M2 2024 (A2898, A2899, A2900)',
      'iPad Pro 11-inch 4th/3rd/2nd/1st gen - 2018-2022 (A2759, A2435, A2761, A2762, A2377, A2301, A2459, A2460, A2228, A2068, A2230, A2231, A1980, A2013, A1934, A1979, A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Pro 12.9 - 6th/5th/4th/3rd Gen (A2436, A2437, A2764, A2766, A2378, A2379, A2461, A2462, A2229, A2069, A2232, A2233, A1876, A2014, A1895, A1983)',
      'iPad Pro 11-inch (M5/M4) 2025/2024 (A2836, A2837, A3006)',
      'iPad Pro 13-inch (M5 2025 / M4 2024) (A2925, A2926, A3007)'
    ]
  },
  {
    id: 'ipad-case-4',
    name: 'Detachable Keyboard Case with Trackpad',
    brand: 'Apple',
    category: 'Protection',
    price: 5999,
    image: detachableCase1,
    images: [detachableCase1, detachableCase2, detachableCase3, detachableCase4, detachableCase5],
    inStock: true,
    stockCount: 35,
    description: 'Ultra-slim detachable magnetic keyboard with precision trackpad and 7-color backlit keys. Converts your iPad into a mini laptop with full protection and adjustable viewing angles.',
    features: [
      'Precision Trackpad: Multi-gesture control for smooth navigation',
      '7-Color Backlit Keyboard: Premium backlit keys for low-light typing',
      'Full Protection: Drop-resistant and scratch-proof design',
      'Adjustable Angles & Pencil Holder: Multiple viewing angles with built-in holder',
      'Perfect for Any Occasion: Lightweight, practical for business, study, or entertainment'
    ],
    compatibleModels: [
      'iPad 11th Gen (A16, 2025) & iPad 10th Generation (A2696, A2757, A2777)',
      'iPad Air 11-inch - M3 2025 / M2 2024 (A2902, A2903, A2904)',
      'iPad Air 10.9inch - 5th/4th Gen (A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Air 13 inch - M3 2025 / M2 2024 (A2898, A2899, A2900)',
      'iPad Pro 11-inch 4th/3rd/2nd/1st gen - 2018-2022 (A2759, A2435, A2761, A2762, A2377, A2301, A2459, A2460, A2228, A2068, A2230, A2231, A1980, A2013, A1934, A1979, A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Pro 12.9 - 6th/5th/4th/3rd Gen (A2436, A2437, A2764, A2766, A2378, A2379, A2461, A2462, A2229, A2069, A2232, A2233, A1876, A2014, A1895, A1983)',
      'iPad Pro 11-inch (M5/M4) 2025/2024 (A2836, A2837, A3006)',
      'iPad Pro 13-inch (M5 2025 / M4 2024) (A2925, A2926, A3007)'
    ]
  },
  {
    id: 'ipad-case-5',
    name: 'Detachable Keyboard Case',
    brand: 'Apple',
    category: 'Protection',
    price: 4999,
    originalPrice: 4999,
    image: detachableCase21,
    images: [detachableCase21, detachableCase22, detachableCase23, detachableCase24, detachableCase25],
    inStock: true,
    stockCount: 40,
    description: 'Ultra-slim detachable magnetic keyboard with 7-color backlit keys. Converts your iPad into a mini laptop with full protection, adjustable viewing angles, and built-in Apple Pencil holder.',
    features: [
      '7-Color Backlit Keyboard: Premium backlit keys for low-light typing',
      'Full Protection: Drop-resistant and scratch-proof design',
      'Adjustable Angles & Pencil Holder: Multiple viewing angles with built-in holder',
      'Perfect for Any Occasion: Lightweight, practical for business, study, or entertainment'
    ],
    compatibleModels: [
      'iPad 11th Gen (A16, 2025) & iPad 10th Generation (A2696, A2757, A2777)',
      'iPad Air 11-inch - M3 2025 / M2 2024 (A2902, A2903, A2904)',
      'iPad Air 10.9inch - 5th/4th Gen (A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Air 13 inch - M3 2025 / M2 2024 (A2898, A2899, A2900)',
      'iPad Pro 11-inch 4th/3rd/2nd/1st gen - 2018-2022 (A2759, A2435, A2761, A2762, A2377, A2301, A2459, A2460, A2228, A2068, A2230, A2231, A1980, A2013, A1934, A1979, A2588, A2589, A2591, A2072, A2316, A2324, A2325)',
      'iPad Pro 12.9 - 6th/5th/4th/3rd Gen (A2436, A2437, A2764, A2766, A2378, A2379, A2461, A2462, A2229, A2069, A2232, A2233, A1876, A2014, A1895, A1983)',
      'iPad Pro 11-inch (M5/M4) 2025/2024 (A2836, A2837, A3006)',
      'iPad Pro 13-inch (M5 2025 / M4 2024) (A2925, A2926, A3007)'
    ]
  }
];

// Coming Soon Products (Samsung, Apple, OnePlus)
const comingSoonProducts = [
  {
    id: 'samsung-1',
    name: 'Galaxy Buds3 Pro',
    brand: 'Samsung',
    category: 'Audio',
    price: 24999,
    image: 'https://images.unsplash.com/photo-1762553159827-7a5d2167b55d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3aXJlbGVzcyUyMGVhcmJ1ZHMlMjBwcmVtaXVtfGVufDF8fHx8MTc2OTAxOTYyNXww&ixlib=rb-4.1.0&q=80&w=1080',
    inStock: false,
    stockCount: 0,
    comingSoon: true,
    description: 'Premium wireless earbuds with advanced ANC and spatial audio.',
    features: ['Active Noise Cancellation', 'Spatial Audio', '8-hour battery', 'IPX7 water resistance']
  },
  {
    id: 'apple-1',
    name: 'AirPods Pro 3',
    brand: 'Apple',
    category: 'Audio',
    price: 29999,
    image: 'https://images.unsplash.com/photo-1762553159827-7a5d2167b55d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3aXJlbGVzcyUyMGVhcmJ1ZHMlMjBwcmVtaXVtfGVufDF8fHx8MTc2OTAxOTYyNXww&ixlib=rb-4.1.0&q=80&w=1080',
    inStock: false,
    stockCount: 0,
    comingSoon: true,
    description: 'Next-generation AirPods Pro with enhanced spatial audio and longer battery life.',
    features: ['Enhanced Spatial Audio', 'Adaptive Transparency', '6-hour battery', 'MagSafe charging']
  },
  {
    id: 'oneplus-1',
    name: 'OnePlus Buds Pro 3',
    brand: 'OnePlus',
    category: 'Audio',
    price: 12999,
    image: 'https://images.unsplash.com/photo-1762553159827-7a5d2167b55d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3aXJlbGVzcyUyMGVhcmJ1ZHMlMjBwcmVtaXVtfGVufDF8fHx8MTc2OTAxOTYyNXww&ixlib=rb-4.1.0&q=80&w=1080',
    inStock: false,
    stockCount: 0,
    comingSoon: true,
    description: 'Premium wireless earbuds with flagship-level audio quality.',
    features: ['Hi-Res Audio', 'Smart ANC', '10-hour battery', 'Fast charging']
  }
];

export const ACCESSORIES_PRODUCTS = [
  ...ipadTypeCaseProducts,
  ...marshallProducts,
  ...muvtechProducts,
  ...comingSoonProducts
];

export default ACCESSORIES_PRODUCTS;